/**
 * @desc 已放行信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.ExportDeclarationYFXRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/exportDeclaration/yfxExportDeclaration`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
